module.exports = __webpack_public_path__ + "img/hw-qrcode.ba4c4df1.png";